import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import * as kmlParser from "@mapbox/togeojson";
import { toast } from "react-toastify";

function UploadKMLDialog({ open, setOpen, type, onKMLParsed }) {
  const [error, setError] = useState("");

  const handleClose = () => {
    setError("");
    setOpen(false);
  };

  const validateGeoJson = (geoJson) => {
    setError("");

    switch (type) {
      case "Photos Plan":
        if (!geoJson.features.every((f) => f.geometry.type === "Point")) {
          setError("Photos Plan can only contain points.");
          return false;
        }
        break;
      case "Videos Plan":
        if (
          !geoJson.features.every((f) =>
            ["LineString", "Circle", "Polygon"].includes(f.geometry.type)
          )
        ) {
          setError("Videos Plan can only contain LineStrings or Circles.");
          return false;
        }
        break;
      case "Photogrammetry Plan":
      case "Lidar Plan":
        if (!geoJson.features.every((f) => f.geometry.type === "Polygon")) {
          setError(`${type} can only contain polygons.`);
          return false;
        }
        break;
      default:
        setError("Invalid plan type.");
        return false;
    }

    return true;
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension !== "kml") {
        setError("Invalid file type. Please upload a .kml file.");
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const parser = new DOMParser();
          const kmlData = parser.parseFromString(
            e.target.result,
            "application/xml"
          );
          const geoJson = kmlParser.kml(kmlData);

          // Assign a unique UUID to each feature's properties
          geoJson.features = geoJson.features.map((feature) => {
            feature.properties = {
              ...feature.properties,
              id: crypto.randomUUID(),
            };
            return feature;
          });

          if (validateGeoJson(geoJson)) {
            toast.success("KML file uploaded successfully");
            onKMLParsed(geoJson, type);
            handleClose();
          }
        } catch (error) {
          setError(
            "Failed to parse the KML file. Please check the file format."
          );
        }
      };

      reader.readAsText(file);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Upload KML File for {type}</DialogTitle>
      <DialogContent
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <label htmlFor="upload-button">
          <Button
            variant="contained"
            color="primary"
            component="span"
            startIcon={<CloudUpload />}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              borderRadius: "8px",
              margin: "20px 0",
            }}
          >
            Upload KML File
          </Button>
        </label>
        <input
          id="upload-button"
          type="file"
          accept=".kml"
          onChange={handleFileUpload}
          style={{ display: "none" }}
        />
        {error && (
          <Alert severity="error" style={{ marginTop: "10px", width: "100%" }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UploadKMLDialog;
